var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "356E04FD-23BF-48FF-97CA-B7D5422D4635") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.807,0.169670289 C6.45,-0.273329711 7.311,0.203670289 7.311,1.00167029 L7.311,1.00167029 L7.311,23.6646703 C7.311,23.9616703 7.184,24.2436703 6.963,24.4336703 L6.963,24.4336703 L1.587,27.7666703 C0.957,28.3096703 -1.53210777e-13,27.8456703 -1.53210777e-13,26.9986703 L-1.53210777e-13,26.9986703 L-1.53210777e-13,3.66867029 C-1.53210777e-13,3.33467029 0.162,3.02167029 0.431,2.83667029 L0.431,2.83667029 Z M10.0001,1.00127029 C10.0001,0.203270289 10.1931,-0.272729711 11.2991,0.169270289 L11.2991,0.169270289 L13.8611,1.02827029 C13.5221,1.43127029 13.2031,1.85627029 12.9341,2.32827029 C11.3611,5.08027029 11.3621,8.48327029 12.9351,11.2092703 L12.9351,11.2092703 L17.7221,19.5002703 C18.2011,20.3312703 19.0581,20.8542703 20.0001,20.9582703 L20.0001,20.9582703 L20.0001,26.9982703 C20.0001,27.8462703 19.6441,28.3092703 18.5591,27.7662703 L18.5591,27.7662703 L10.6001,24.4332703 C10.2201,24.2432703 10.0001,23.9612703 10.0001,23.6652703 L10.0001,23.6652703 Z M28.4955,0.169670289 C29.1395,-0.273329711 30.0005,0.203670289 30.0005,1.00167029 L30.0005,1.00167029 L30.0005,23.6646703 C30.0005,23.9616703 29.8725,24.2436703 29.6515,24.4336703 L29.6515,24.4336703 L24.2765,27.7666703 C23.6455,28.3096703 22.6895,27.8456703 22.6895,26.9986703 L22.6895,26.9986703 L22.6895,19.7966703 C22.7655,19.6976703 22.8545,19.6096703 22.9185,19.5006703 L22.9185,19.5006703 L27.8255,11.0006703 C29.3915,8.28667029 29.3915,5.04667029 27.8255,2.33367029 C27.5425,1.84367029 27.2065,1.40267029 26.8485,0.986670289 L26.8485,0.986670289 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3666,9.50027029 C5.7106,9.50027029 4.3666,8.15727029 4.3666,6.50027029 C4.3666,4.84327029 5.7106,3.50027029 7.3666,3.50027029 C9.0236,3.50027029 10.3666,4.84327029 10.3666,6.50027029 C10.3666,8.15727029 9.0236,9.50027029 7.3666,9.50027029 M7.2576,0.00027028888 C2.1516,0.0452702889 -0.8854,5.78827029 1.6676,10.2092703 L6.4536,18.5002703 C6.8396,19.1672703 7.8016,19.1672703 8.1856,18.5002703 L13.0936,10.0002703 C15.6696,5.53827029 12.4266,-0.0447297111 7.2576,0.00027028888",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-WebPageBuilder-EmptyWidgets",
    transform: "translate(-203.000000, -248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WPB-Widgets",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components",
    transform: "translate(160.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Map/40dp",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(5.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey",
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.000000, -6.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(18.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Dark",
    mask: "url(#mask-4)",
    fill: "#727272"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.000000, -6.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.09dee41ec4cdad2d5928d0282f30683d.svg";
export { ForwardRef as ReactComponent };